import React from "react";
import { Divider, Paper } from "convertupleads-theme";
import PageTitleBox from "../../../common/PageTitleBox";
import BasicAlerts from "./BasicAlerts";
import AlertDescription from "./AlertDescription";
import AlertActions from "./AlertActions";
import AlertIcons from "./AlertIcons";
import AlertVariants from "./AlertVariants";
import AlertColor from "./AlertColor";

const AlertPage = () => {
  return (
    <Paper elevation={0}>
      <PageTitleBox
        title={"Alert"}
        description={
          "An alert displays a short, important message in a way that attracts the user's attention without interrupting the user's task."
        }
      />
      <Divider light />

      <BasicAlerts />
      <AlertDescription />
      <AlertActions />
      <AlertIcons />
      <AlertVariants />
      <AlertColor />
    </Paper>
  );
};

export default AlertPage;
